// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3jxnn","messages":"Chat_messages__32gs4","dateDivider":"Chat_dateDivider__2Ln0F"};